import { render } from "./AssetList.vue?vue&type=template&id=448f1a5e&scoped=true"
import script from "./AssetList.vue?vue&type=script&lang=js"
export * from "./AssetList.vue?vue&type=script&lang=js"

import "./AssetList.vue?vue&type=style&index=0&id=448f1a5e&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/dynamic-builder/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-448f1a5e"]])

export default __exports__